import gsap from "@lib/gsap";
import { Draggable } from "gsap/dist/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import { onDestroy } from "./_";
import { Resize } from "@/lib/subs";

gsap.registerPlugin(Draggable, InertiaPlugin);

export default function (element, dataset) {
  const list = element.querySelector(".cwtl_list");
  if (!list) return;

  let draggableInstance = null;

  function getBounds() {
    const wrapWidth = element.offsetWidth;
    const listWidth = list.scrollWidth;
    const overflow = listWidth - wrapWidth;
    return { wrapWidth, listWidth, overflow };
  }

  function create() {
    const { overflow } = getBounds();

    if (overflow <= 0) {
      // No overflow — kill any existing draggable and reset position
      if (draggableInstance) {
        draggableInstance[0].kill();
        draggableInstance = null;
        gsap.set(list, { x: 0 });
      }
      return;
    }

    // Already active — just update bounds
    if (draggableInstance) {
      draggableInstance[0].applyBounds({ minX: -overflow - 32, maxX: 0 });
      // Clamp current position if it's now out of range
      if (draggableInstance[0].x < -overflow - 32) {
        gsap.set(list, { x: -overflow - 32 });
        draggableInstance[0].update();
      }
      return;
    }

    draggableInstance = Draggable.create(list, {
      type: "x",
      bounds: { minX: -overflow - 32, maxX: 0 },
      inertia: true,
      edgeResistance: 0.65,
      cursor: "grab",
      activeCursor: "grabbing",
    });
  }

  create();

  const removeResize = Resize.add(() => create());

  onDestroy(() => {
    if (draggableInstance) {
      draggableInstance[0].kill();
    }
    gsap.set(list, { clearProps: "x" });
    removeResize();
  });
}
